import script from "./Features.vue?vue&type=script&setup=true&lang=js"
export * from "./Features.vue?vue&type=script&setup=true&lang=js"

import "./Features.vue?vue&type=style&index=0&id=ec8eefc0&lang=pcss"

const __exports__ = script;

export default __exports__